import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-headline-large',
  imports: [NgClass],
  templateUrl: './headline-large.html',
  styleUrl: './headline-large.css'
})
export class HeadlineLarge {
  @Input() title!: string;
  @Input() class!: string;
}
